function initVtSwatches() {
  document.querySelectorAll('[id^="vt-comprar-swatches-"]').forEach(function (group) {
    var sectionId = group.id.replace('vt-comprar-swatches-', '');
    var img = document.getElementById('vt-comprar-img-' + sectionId);
    var priceEl = document.getElementById('vt-comprar-price-' + sectionId);
    var hiddenInput = document.getElementById('vt-comprar-variant-id-' + sectionId);
    var cta = document.getElementById('vt-comprar-cta-' + sectionId);
    if (!hiddenInput || !cta) return;

    group.querySelectorAll('.vt-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.vt-swatch').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        hiddenInput.value = btn.getAttribute('data-vt-variant-id');

        if (img && btn.getAttribute('data-vt-variant-image')) {
          img.src = btn.getAttribute('data-vt-variant-image');
        }
        if (priceEl) {
          priceEl.textContent = btn.getAttribute('data-vt-variant-price');
        }

        var available = btn.getAttribute('data-vt-variant-available') === 'true';
        cta.disabled = !available;
        cta.textContent = available
          ? cta.getAttribute('data-label-buy')
          : cta.getAttribute('data-label-sold-out');
      });
    });
  });
}

initVtSwatches();
document.addEventListener('shopify:section:load', initVtSwatches);
